export const TrackingServices = Object.freeze({
  amplitude: 'amplitude',
});
